import { NgModule } from '@angular/core';
import { LibEuroTransactionsIconComponent } from './lib-euro-transactions-icon.component';

@NgModule({
  declarations: [LibEuroTransactionsIconComponent],
  exports: [LibEuroTransactionsIconComponent],
})
export class LibEuroTransactionsIconModule {}
